import {LangKeys} from "locales/i18n";

export default {
   [LangKeys.en]: {
       title: "Terms | Pumpkin Meet",
       description: "",
   },
}